export type MerchantCategory = {
  category: string;
  code: string;
  description: string;
};

export const merchantCategoryCodes: MerchantCategory[] = [
  {
    category: "ac_refrigeration_repair",
    code: "7623",
    description: "A/C, Refrigeration Repair",
  },
  {
    description: "Accounting/Bookkeeping Services",
    category: "accounting_bookkeeping_services",
    code: "8931",
  },
  {
    description: "Advertising Services",
    category: "advertising_services",
    code: "7311",
  },
  {
    description: "Agricultural Cooperative",
    category: "agricultural_cooperative",
    code: "0763",
  },
  {
    description: "Airlines, Air Carriers",
    category: "airlines_air_carriers",
    code: "4511",
  },
  {
    description: "Airports, Flying Fields",
    category: "airports_flying_fields",
    code: "4582",
  },
  {
    description: "Ambulance Services",
    category: "ambulance_services",
    code: "4119",
  },
  {
    description: "Amusement Parks/Carnivals",
    category: "amusement_parks_carnivals",
    code: "7996",
  },
  {
    description: "Antique Reproductions",
    category: "antique_reproductions",
    code: "5937",
  },
  { description: "Antique Shops", category: "antique_shops", code: "5932" },
  { description: "Aquariums", category: "aquariums", code: "7998" },
  {
    description: "Architectural/Surveying Services",
    category: "architectural_surveying_services",
    code: "8911",
  },
  {
    description: "Art Dealers and Galleries",
    category: "art_dealers_and_galleries",
    code: "5971",
  },
  {
    description: "Artists Supply and Craft Shops",
    category: "artists_supply_and_craft_shops",
    code: "5970",
  },
  {
    description: "Auto Body Repair Shops",
    category: "auto_body_repair_shops",
    code: "7531",
  },
  {
    description: "Auto Paint Shops",
    category: "auto_paint_shops",
    code: "7535",
  },
  {
    description: "Auto Service Shops",
    category: "auto_service_shops",
    code: "7538",
  },
  {
    description: "Auto and Home Supply Stores",
    category: "auto_and_home_supply_stores",
    code: "5531",
  },
  {
    description: "Automated Cash Disburse",
    category: "automated_cash_disburse",
    code: "6011",
  },
  {
    description: "Automated Fuel Dispensers",
    category: "automated_fuel_dispensers",
    code: "5542",
  },
  {
    description: "Automobile Associations",
    category: "automobile_associations",
    code: "8675",
  },
  {
    description: "Automotive Parts and Accessories Stores",
    category: "automotive_parts_and_accessories_stores",
    code: "5533",
  },
  {
    description: "Automotive Tire Stores",
    category: "automotive_tire_stores",
    code: "5532",
  },
  {
    description:
      "Bail and Bond Payments (payment to the surety for the bond, not the actual bond paid to the government agency)",
    category: "bail_and_bond_payments",
    code: "9223",
  },
  { description: "Bakeries", category: "bakeries", code: "5462" },
  {
    description: "Bands, Orchestras",
    category: "bands_orchestras",
    code: "7929",
  },
  {
    description: "Barber and Beauty Shops",
    category: "barber_and_beauty_shops",
    code: "7230",
  },
  {
    description: "Betting/Casino Gambling",
    category: "betting_casino_gambling",
    code: "7995",
  },
  { description: "Bicycle Shops", category: "bicycle_shops", code: "5940" },
  {
    description: "Billiard/Pool Establishments",
    category: "billiard_pool_establishments",
    code: "7932",
  },
  { description: "Boat Dealers", category: "boat_dealers", code: "5551" },
  {
    description: "Boat Rentals and Leases",
    category: "boat_rentals_and_leases",
    code: "4457",
  },
  { description: "Book Stores", category: "book_stores", code: "5942" },
  {
    description: "Books, Periodicals, and Newspapers",
    category: "books_periodicals_and_newspapers",
    code: "5192",
  },
  { description: "Bowling Alleys", category: "bowling_alleys", code: "7933" },
  { description: "Bus Lines", category: "bus_lines", code: "4131" },
  {
    description: "Business/Secretarial Schools",
    category: "business_secretarial_schools",
    code: "8244",
  },
  {
    description: "Buying/Shopping Services",
    category: "buying_shopping_services",
    code: "7278",
  },
  {
    description: "Cable, Satellite, and Other Pay Television and Radio",
    category: "cable_satellite_and_other_pay_television_and_radio",
    code: "4899",
  },
  {
    description: "Camera and Photographic Supply Stores",
    category: "camera_and_photographic_supply_stores",
    code: "5946",
  },
  {
    description: "Candy, Nut, and Confectionery Stores",
    category: "candy_nut_and_confectionery_stores",
    code: "5441",
  },
  {
    description: "Car Rental Agencies",
    category: "car_rental_agencies",
    code: "7512",
  },
  { description: "Car Washes", category: "car_washes", code: "7542" },
  {
    description:
      "Car and Truck Dealers (New & Used) Sales, Service, Repairs Parts and Leasing",
    category: "car_and_truck_dealers_new_used",
    code: "5511",
  },
  {
    description:
      "Car and Truck Dealers (Used Only) Sales, Service, Repairs Parts and Leasing",
    category: "car_and_truck_dealers_used_only",
    code: "5521",
  },
  {
    description: "Carpentry Services",
    category: "carpentry_services",
    code: "1750",
  },
  {
    description: "Carpet/Upholstery Cleaning",
    category: "carpet_upholstery_cleaning",
    code: "7217",
  },
  { description: "Caterers", category: "caterers", code: "5811" },
  {
    description: "Charitable and Social Service Organizations - Fundraising",
    category: "charitable_and_social_service_organizations_fundraising",
    code: "8398",
  },
  {
    description: "Chemicals and Allied Products (Not Elsewhere Classified)",
    category: "chemicals_and_allied_products",
    code: "5169",
  },
  {
    description: "Child Care Services",
    category: "child_care_services",
    code: "8351",
  },
  {
    description: "Childrens and Infants Wear Stores",
    category: "childrens_and_infants_wear_stores",
    code: "5641",
  },
  {
    description: "Chiropodists, Podiatrists",
    category: "chiropodists_podiatrists",
    code: "8049",
  },
  { description: "Chiropractors", category: "chiropractors", code: "8041" },
  {
    description: "Cigar Stores and Stands",
    category: "cigar_stores_and_stands",
    code: "5993",
  },
  {
    description: "Civic, Social, Fraternal Associations",
    category: "civic_social_fraternal_associations",
    code: "8641",
  },
  {
    description: "Cleaning and Maintenance",
    category: "cleaning_and_maintenance",
    code: "7349",
  },
  { description: "Clothing Rental", category: "clothing_rental", code: "7296" },
  {
    description: "Colleges, Universities",
    category: "colleges_universities",
    code: "8220",
  },
  {
    description: "Commercial Equipment (Not Elsewhere Classified)",
    category: "commercial_equipment",
    code: "5046",
  },
  {
    description: "Commercial Footwear",
    category: "commercial_footwear",
    code: "5139",
  },
  {
    description: "Commercial Photography, Art and Graphics",
    category: "commercial_photography_art_and_graphics",
    code: "7333",
  },
  {
    description: "Commuter Transport, Ferries",
    category: "commuter_transport_and_ferries",
    code: "4111",
  },
  {
    description: "Computer Network Services",
    category: "computer_network_services",
    code: "4816",
  },
  {
    description: "Computer Programming",
    category: "computer_programming",
    code: "7372",
  },
  { description: "Computer Repair", category: "computer_repair", code: "7379" },
  {
    description: "Computer Software Stores",
    category: "computer_software_stores",
    code: "5734",
  },
  {
    description: "Computers, Peripherals, and Software",
    category: "computers_peripherals_and_software",
    code: "5045",
  },
  {
    description: "Concrete Work Services",
    category: "concrete_work_services",
    code: "1771",
  },
  {
    description: "Construction Materials (Not Elsewhere Classified)",
    category: "construction_materials",
    code: "5039",
  },
  {
    description: "Consulting, Public Relations",
    category: "consulting_public_relations",
    code: "7392",
  },
  {
    description: "Correspondence Schools",
    category: "correspondence_schools",
    code: "8241",
  },
  { description: "Cosmetic Stores", category: "cosmetic_stores", code: "5977" },
  {
    description: "Counseling Services",
    category: "counseling_services",
    code: "7277",
  },
  { description: "Country Clubs", category: "country_clubs", code: "7997" },
  {
    description: "Courier Services",
    category: "courier_services",
    code: "4215",
  },
  {
    description:
      "Court Costs, Including Alimony and Child Support - Courts of Law",
    category: "court_costs",
    code: "9211",
  },
  {
    description: "Credit Reporting Agencies",
    category: "credit_reporting_agencies",
    code: "7321",
  },
  { description: "Cruise Lines", category: "cruise_lines", code: "4411" },
  {
    description: "Dairy Products Stores",
    category: "dairy_products_stores",
    code: "5451",
  },
  {
    description: "Dance Hall, Studios, Schools",
    category: "dance_hall_studios_schools",
    code: "7911",
  },
  {
    description: "Dating/Escort Services",
    category: "dating_escort_services",
    code: "7273",
  },
  {
    description: "Dentists, Orthodontists",
    category: "dentists_orthodontists",
    code: "8021",
  },
  {
    description: "Department Stores",
    category: "department_stores",
    code: "5311",
  },
  {
    description: "Detective Agencies",
    category: "detective_agencies",
    code: "7393",
  },
  {
    description: "Digital Goods Media – Books, Movies, Music",
    category: "digital_goods_media",
    code: "5815",
  },
  {
    description: "Digital Goods – Applications (Excludes Games)",
    category: "digital_goods_applications",
    code: "5817",
  },
  {
    description: "Digital Goods – Games",
    category: "digital_goods_games",
    code: "5816",
  },
  {
    description: "Digital Goods – Large Digital Goods Merchant",
    category: "digital_goods_large_volume",
    code: "5818",
  },
  {
    description: "Direct Marketing - Catalog Merchant",
    category: "direct_marketing_catalog_merchant",
    code: "5964",
  },
  {
    description: "Direct Marketing - Combination Catalog and Retail Merchant",
    category: "direct_marketing_combination_catalog_and_retail_merchant",
    code: "5965",
  },
  {
    description: "Direct Marketing - Inbound Telemarketing",
    category: "direct_marketing_inbound_telemarketing",
    code: "5967",
  },
  {
    description: "Direct Marketing - Insurance Services",
    category: "direct_marketing_insurance_services",
    code: "5960",
  },
  {
    description: "Direct Marketing - Other",
    category: "direct_marketing_other",
    code: "5969",
  },
  {
    description: "Direct Marketing - Outbound Telemarketing",
    category: "direct_marketing_outbound_telemarketing",
    code: "5966",
  },
  {
    description: "Direct Marketing - Subscription",
    category: "direct_marketing_subscription",
    code: "5968",
  },
  {
    description: "Direct Marketing - Travel",
    category: "direct_marketing_travel",
    code: "5962",
  },
  { description: "Discount Stores", category: "discount_stores", code: "5310" },
  { description: "Doctors", category: "doctors", code: "8011" },
  {
    description: "Door-To-Door Sales",
    category: "door_to_door_sales",
    code: "5963",
  },
  {
    description: "Drapery, Window Covering, and Upholstery Stores",
    category: "drapery_window_covering_and_upholstery_stores",
    code: "5714",
  },
  { description: "Drinking Places", category: "drinking_places", code: "5813" },
  {
    description: "Drug Stores and Pharmacies",
    category: "drug_stores_and_pharmacies",
    code: "5912",
  },
  {
    description: "Drugs, Drug Proprietaries, and Druggist Sundries",
    category: "drugs_drug_proprietaries_and_druggist_sundries",
    code: "5122",
  },
  { description: "Dry Cleaners", category: "dry_cleaners", code: "7216" },
  {
    description: "Durable Goods (Not Elsewhere Classified)",
    category: "durable_goods",
    code: "5099",
  },
  {
    description: "Duty Free Stores",
    category: "duty_free_stores",
    code: "5309",
  },
  {
    description: "Eating Places, Restaurants",
    category: "eating_places_restaurants",
    code: "5812",
  },
  {
    description: "Educational Services",
    category: "educational_services",
    code: "8299",
  },
  {
    description: "Electric Razor Stores",
    category: "electric_razor_stores",
    code: "5997",
  },
  {
    description: "Electric Vehicle Charging",
    category: "electric_vehicle_charging",
    code: "5552",
  },
  {
    description: "Electrical Parts and Equipment",
    category: "electrical_parts_and_equipment",
    code: "5065",
  },
  {
    description: "Electrical Services",
    category: "electrical_services",
    code: "1731",
  },
  {
    description: "Electronics Repair Shops",
    category: "electronics_repair_shops",
    code: "7622",
  },
  {
    description: "Electronics Stores",
    category: "electronics_stores",
    code: "5732",
  },
  {
    description: "Elementary, Secondary Schools",
    category: "elementary_secondary_schools",
    code: "8211",
  },
  {
    description: "Emergency Services (GCAS) (Visa use only)",
    category: "emergency_services_gcas_visa_use_only",
    code: "9702",
  },
  {
    description: "Employment/Temp Agencies",
    category: "employment_temp_agencies",
    code: "7361",
  },
  {
    description: "Equipment Rental",
    category: "equipment_rental",
    code: "7394",
  },
  {
    description: "Exterminating Services",
    category: "exterminating_services",
    code: "7342",
  },
  {
    description: "Family Clothing Stores",
    category: "family_clothing_stores",
    code: "5651",
  },
  {
    description: "Fast Food Restaurants",
    category: "fast_food_restaurants",
    code: "5814",
  },
  {
    description: "Financial Institutions",
    category: "financial_institutions",
    code: "6012",
  },
  {
    description: "Fines - Government Administrative Entities",
    category: "fines_government_administrative_entities",
    code: "9222",
  },
  {
    description: "Fireplace, Fireplace Screens, and Accessories Stores",
    category: "fireplace_fireplace_screens_and_accessories_stores",
    code: "5718",
  },
  {
    description: "Floor Covering Stores",
    category: "floor_covering_stores",
    code: "5713",
  },
  { description: "Florists", category: "florists", code: "5992" },
  {
    description: "Florists Supplies, Nursery Stock, and Flowers",
    category: "florists_supplies_nursery_stock_and_flowers",
    code: "5193",
  },
  {
    description: "Freezer and Locker Meat Provisioners",
    category: "freezer_and_locker_meat_provisioners",
    code: "5422",
  },
  {
    description: "Fuel Dealers (Non Automotive)",
    category: "fuel_dealers_non_automotive",
    code: "5983",
  },
  {
    description: "Funeral Services, Crematories",
    category: "funeral_services_crematories",
    code: "7261",
  },
  {
    description: "Furniture Repair, Refinishing",
    category: "furniture_repair_refinishing",
    code: "7641",
  },
  {
    description:
      "Furniture, Home Furnishings, and Equipment Stores, Except Appliances",
    category:
      "furniture_home_furnishings_and_equipment_stores_except_appliances",
    code: "5712",
  },
  {
    description: "Furriers and Fur Shops",
    category: "furriers_and_fur_shops",
    code: "5681",
  },
  {
    description: "General Services",
    category: "general_services",
    code: "1520",
  },
  {
    description: "Gift, Card, Novelty, and Souvenir Shops",
    category: "gift_card_novelty_and_souvenir_shops",
    code: "5947",
  },
  {
    description: "Glass, Paint, and Wallpaper Stores",
    category: "glass_paint_and_wallpaper_stores",
    code: "5231",
  },
  {
    description: "Glassware, Crystal Stores",
    category: "glassware_crystal_stores",
    code: "5950",
  },
  {
    description: "Golf Courses - Public",
    category: "golf_courses_public",
    code: "7992",
  },
  {
    description:
      "Government Licensed On-line Casinos (On-Line Gambling)(US Region only)",
    category:
      "government_licensed_online_casions_online_gambling_us_region_only",
    code: "7801",
  },
  {
    description: "Government Services (Not Elsewhere Classified)",
    category: "government_services",
    code: "9399",
  },
  {
    description: "Government-Licensed Horse/Dog Racing (US Region only)",
    category: "government_licensed_horse_dog_racing_us_region_only",
    code: "7802",
  },
  {
    description: "Government-Owned Lotteries (Non-US region)",
    category: "government_owned_lotteries_non_us_region",
    code: "9406",
  },
  {
    description: "Government-Owned Lotteries (US Region only)",
    category: "government_owned_lotteries_us_region_only",
    code: "7800",
  },
  {
    description: "Grocery Stores, Supermarkets",
    category: "grocery_stores_supermarkets",
    code: "5411",
  },
  { description: "Hardware Stores", category: "hardware_stores", code: "5251" },
  {
    description: "Hardware, Equipment, and Supplies",
    category: "hardware_equipment_and_supplies",
    code: "5072",
  },
  {
    description: "Health and Beauty Spas",
    category: "health_and_beauty_spas",
    code: "7298",
  },
  {
    description: "Hearing Aids Sales and Supplies",
    category: "hearing_aids_sales_and_supplies",
    code: "5975",
  },
  {
    description: "Heating, Plumbing, A/C",
    category: "heating_plumbing_a_c",
    code: "1711",
  },
  {
    description: "Hobby, Toy, and Game Shops",
    category: "hobby_toy_and_game_shops",
    code: "5945",
  },
  {
    description: "Home Supply Warehouse Stores",
    category: "home_supply_warehouse_stores",
    code: "5200",
  },
  { description: "Hospitals", category: "hospitals", code: "8062" },
  {
    description: "Hotels, Motels, and Resorts",
    category: "hotels_motels_and_resorts",
    code: "7011",
  },
  {
    description: "Household Appliance Stores",
    category: "household_appliance_stores",
    code: "5722",
  },
  {
    description: "Industrial Supplies (Not Elsewhere Classified)",
    category: "industrial_supplies",
    code: "5085",
  },
  {
    description: "Information Retrieval Services",
    category: "information_retrieval_services",
    code: "7375",
  },
  {
    description: "Insurance - Default",
    category: "insurance_default",
    code: "6399",
  },
  {
    description: "Insurance Underwriting, Premiums",
    category: "insurance_underwriting_premiums",
    code: "6300",
  },
  {
    description: "Intra-Company Purchases",
    category: "intra_company_purchases",
    code: "9950",
  },
  {
    description: "Jewelry Stores, Watches, Clocks, and Silverware Stores",
    category: "jewelry_stores_watches_clocks_and_silverware_stores",
    code: "5944",
  },
  {
    description: "Landscaping Services",
    category: "landscaping_services",
    code: "0780",
  },
  { description: "Laundries", category: "laundries", code: "7211" },
  {
    description: "Laundry, Cleaning Services",
    category: "laundry_cleaning_services",
    code: "7210",
  },
  {
    description: "Legal Services, Attorneys",
    category: "legal_services_attorneys",
    code: "8111",
  },
  {
    description: "Luggage and Leather Goods Stores",
    category: "luggage_and_leather_goods_stores",
    code: "5948",
  },
  {
    description: "Lumber, Building Materials Stores",
    category: "lumber_building_materials_stores",
    code: "5211",
  },
  {
    description: "Manual Cash Disburse",
    category: "manual_cash_disburse",
    code: "6010",
  },
  {
    description: "Marinas, Service and Supplies",
    category: "marinas_service_and_supplies",
    code: "4468",
  },
  {
    description: "Masonry, Stonework, and Plaster",
    category: "masonry_stonework_and_plaster",
    code: "1740",
  },
  { description: "Massage Parlors", category: "massage_parlors", code: "7297" },
  {
    description: "Medical Services",
    category: "medical_services",
    code: "8099",
  },
  {
    description: "Medical and Dental Labs",
    category: "medical_and_dental_labs",
    code: "8071",
  },
  {
    description:
      "Medical, Dental, Ophthalmic, and Hospital Equipment and Supplies",
    category: "medical_dental_ophthalmic_and_hospital_equipment_and_supplies",
    code: "5047",
  },
  {
    description: "Membership Organizations",
    category: "membership_organizations",
    code: "8699",
  },
  {
    description: "Mens and Boys Clothing and Accessories Stores",
    category: "mens_and_boys_clothing_and_accessories_stores",
    code: "5611",
  },
  {
    description: "Mens, Womens Clothing Stores",
    category: "mens_womens_clothing_stores",
    code: "5691",
  },
  {
    description: "Metal Service Centers",
    category: "metal_service_centers",
    code: "5051",
  },
  {
    description: "Miscellaneous Apparel and Accessory Shops",
    category: "miscellaneous_apparel_and_accessory_shops",
    code: "5699",
  },
  {
    description: "Miscellaneous Auto Dealers",
    category: "miscellaneous_auto_dealers",
    code: "5599",
  },
  {
    description: "Miscellaneous Business Services",
    category: "miscellaneous_business_services",
    code: "7399",
  },
  {
    description:
      "Miscellaneous Food Stores - Convenience Stores and Specialty Markets",
    category: "miscellaneous_food_stores",
    code: "5499",
  },
  {
    description: "Miscellaneous General Merchandise",
    category: "miscellaneous_general_merchandise",
    code: "5399",
  },
  {
    description: "Miscellaneous General Services",
    category: "miscellaneous_general_services",
    code: "7299",
  },
  {
    description: "Miscellaneous Home Furnishing Specialty Stores",
    category: "miscellaneous_home_furnishing_specialty_stores",
    code: "5719",
  },
  {
    description: "Miscellaneous Publishing and Printing",
    category: "miscellaneous_publishing_and_printing",
    code: "2741",
  },
  {
    description: "Miscellaneous Recreation Services",
    category: "miscellaneous_recreation_services",
    code: "7999",
  },
  {
    description: "Miscellaneous Repair Shops",
    category: "miscellaneous_repair_shops",
    code: "7699",
  },
  {
    description: "Miscellaneous Specialty Retail",
    category: "miscellaneous_specialty_retail",
    code: "5999",
  },
  {
    description: "Mobile Home Dealers",
    category: "mobile_home_dealers",
    code: "5271",
  },
  {
    description: "Motion Picture Theaters",
    category: "motion_picture_theaters",
    code: "7832",
  },
  {
    description:
      "Motor Freight Carriers and Trucking - Local and Long Distance, Moving and Storage Companies, and Local Delivery Services",
    category: "motor_freight_carriers_and_trucking",
    code: "4214",
  },
  {
    description: "Motor Homes Dealers",
    category: "motor_homes_dealers",
    code: "5592",
  },
  {
    description: "Motor Vehicle Supplies and New Parts",
    category: "motor_vehicle_supplies_and_new_parts",
    code: "5013",
  },
  {
    description: "Motorcycle Shops and Dealers",
    category: "motorcycle_shops_and_dealers",
    code: "5571",
  },
  {
    description: "Motorcycle Shops, Dealers",
    category: "motorcycle_shops_dealers",
    code: "5561",
  },
  {
    description: "Music Stores-Musical Instruments, Pianos, and Sheet Music",
    category: "music_stores_musical_instruments_pianos_and_sheet_music",
    code: "5733",
  },
  {
    description: "News Dealers and Newsstands",
    category: "news_dealers_and_newsstands",
    code: "5994",
  },
  {
    description: "Non-FI, Money Orders",
    category: "non_fi_money_orders",
    code: "6051",
  },
  {
    description: "Non-FI, Stored Value Card Purchase/Load",
    category: "non_fi_stored_value_card_purchase_load",
    code: "6540",
  },
  {
    description: "Nondurable Goods (Not Elsewhere Classified)",
    category: "nondurable_goods",
    code: "5199",
  },
  {
    description: "Nurseries, Lawn and Garden Supply Stores",
    category: "nurseries_lawn_and_garden_supply_stores",
    code: "5261",
  },
  {
    description: "Nursing/Personal Care",
    category: "nursing_personal_care",
    code: "8050",
  },
  {
    description: "Office and Commercial Furniture",
    category: "office_and_commercial_furniture",
    code: "5021",
  },
  {
    description: "Opticians, Eyeglasses",
    category: "opticians_eyeglasses",
    code: "8043",
  },
  {
    description: "Optometrists, Ophthalmologist",
    category: "optometrists_ophthalmologist",
    code: "8042",
  },
  {
    description: "Orthopedic Goods - Prosthetic Devices",
    category: "orthopedic_goods_prosthetic_devices",
    code: "5976",
  },
  { description: "Osteopaths", category: "osteopaths", code: "8031" },
  {
    description: "Package Stores-Beer, Wine, and Liquor",
    category: "package_stores_beer_wine_and_liquor",
    code: "5921",
  },
  {
    description: "Paints, Varnishes, and Supplies",
    category: "paints_varnishes_and_supplies",
    code: "5198",
  },
  {
    description: "Parking Lots, Garages",
    category: "parking_lots_garages",
    code: "7523",
  },
  {
    description: "Passenger Railways",
    category: "passenger_railways",
    code: "4112",
  },
  { description: "Pawn Shops", category: "pawn_shops", code: "5933" },
  {
    description: "Pet Shops, Pet Food, and Supplies",
    category: "pet_shops_pet_food_and_supplies",
    code: "5995",
  },
  {
    description: "Petroleum and Petroleum Products",
    category: "petroleum_and_petroleum_products",
    code: "5172",
  },
  {
    description: "Photo Developing",
    category: "photo_developing",
    code: "7395",
  },
  {
    description: "Photographic Studios",
    category: "photographic_studios",
    code: "7221",
  },
  {
    description: "Photographic, Photocopy, Microfilm Equipment, and Supplies",
    category: "photographic_photocopy_microfilm_equipment_and_supplies",
    code: "5044",
  },
  {
    description: "Picture/Video Production",
    category: "picture_video_production",
    code: "7829",
  },
  {
    description: "Piece Goods, Notions, and Other Dry Goods",
    category: "piece_goods_notions_and_other_dry_goods",
    code: "5131",
  },
  {
    description: "Plumbing, Heating Equipment, and Supplies",
    category: "plumbing_heating_equipment_and_supplies",
    code: "5074",
  },
  {
    description: "Political Organizations",
    category: "political_organizations",
    code: "8651",
  },
  {
    description: "Postal Services - Government Only",
    category: "postal_services_government_only",
    code: "9402",
  },
  {
    description: "Precious Stones and Metals, Watches and Jewelry",
    category: "precious_stones_and_metals_watches_and_jewelry",
    code: "5094",
  },
  {
    description: "Professional Services",
    category: "professional_services",
    code: "8999",
  },
  {
    description:
      "Public Warehousing and Storage - Farm Products, Refrigerated Goods, Household Goods, and Storage",
    category: "public_warehousing_and_storage",
    code: "4225",
  },
  {
    description: "Quick Copy, Repro, and Blueprint",
    category: "quick_copy_repro_and_blueprint",
    code: "7338",
  },
  { description: "Railroads", category: "railroads", code: "4011" },
  {
    description: "Real Estate Agents and Managers - Rentals",
    category: "real_estate_agents_and_managers_rentals",
    code: "6513",
  },
  { description: "Record Stores", category: "record_stores", code: "5735" },
  {
    description: "Recreational Vehicle Rentals",
    category: "recreational_vehicle_rentals",
    code: "7519",
  },
  {
    description: "Religious Goods Stores",
    category: "religious_goods_stores",
    code: "5973",
  },
  {
    description: "Religious Organizations",
    category: "religious_organizations",
    code: "8661",
  },
  {
    description: "Roofing/Siding, Sheet Metal",
    category: "roofing_siding_sheet_metal",
    code: "1761",
  },
  {
    description: "Secretarial Support Services",
    category: "secretarial_support_services",
    code: "7339",
  },
  {
    description: "Security Brokers/Dealers",
    category: "security_brokers_dealers",
    code: "6211",
  },
  {
    description: "Service Stations",
    category: "service_stations",
    code: "5541",
  },
  {
    description: "Sewing, Needlework, Fabric, and Piece Goods Stores",
    category: "sewing_needlework_fabric_and_piece_goods_stores",
    code: "5949",
  },
  {
    description: "Shoe Repair/Hat Cleaning",
    category: "shoe_repair_hat_cleaning",
    code: "7251",
  },
  { description: "Shoe Stores", category: "shoe_stores", code: "5661" },
  {
    description: "Small Appliance Repair",
    category: "small_appliance_repair",
    code: "7629",
  },
  {
    description: "Snowmobile Dealers",
    category: "snowmobile_dealers",
    code: "5598",
  },
  {
    description: "Special Trade Services",
    category: "special_trade_services",
    code: "1799",
  },
  {
    description: "Specialty Cleaning",
    category: "specialty_cleaning",
    code: "2842",
  },
  {
    description: "Sporting Goods Stores",
    category: "sporting_goods_stores",
    code: "5941",
  },
  {
    description: "Sporting/Recreation Camps",
    category: "sporting_recreation_camps",
    code: "7032",
  },
  {
    description: "Sports Clubs/Fields",
    category: "sports_clubs_fields",
    code: "7941",
  },
  {
    description: "Sports and Riding Apparel Stores",
    category: "sports_and_riding_apparel_stores",
    code: "5655",
  },
  {
    description: "Stamp and Coin Stores",
    category: "stamp_and_coin_stores",
    code: "5972",
  },
  {
    description: "Stationery Stores, Office, and School Supply Stores",
    category: "stationery_stores_office_and_school_supply_stores",
    code: "5943",
  },
  {
    description: "Stationery, Office Supplies, Printing and Writing Paper",
    category: "stationary_office_supplies_printing_and_writing_paper",
    code: "5111",
  },
  {
    description: "Swimming Pools Sales",
    category: "swimming_pools_sales",
    code: "5996",
  },
  {
    description: "TUI Travel - Germany",
    category: "t_ui_travel_germany",
    code: "4723",
  },
  {
    description: "Tailors, Alterations",
    category: "tailors_alterations",
    code: "5697",
  },
  {
    description: "Tax Payments - Government Agencies",
    category: "tax_payments_government_agencies",
    code: "9311",
  },
  {
    description: "Tax Preparation Services",
    category: "tax_preparation_services",
    code: "7276",
  },
  {
    description: "Taxicabs/Limousines",
    category: "taxicabs_limousines",
    code: "4121",
  },
  {
    description: "Telecommunication Equipment and Telephone Sales",
    category: "telecommunication_equipment_and_telephone_sales",
    code: "4812",
  },
  {
    description: "Telecommunication Services",
    category: "telecommunication_services",
    code: "4814",
  },
  {
    description: "Telegraph Services",
    category: "telegraph_services",
    code: "4821",
  },
  {
    description: "Tent and Awning Shops",
    category: "tent_and_awning_shops",
    code: "5998",
  },
  {
    description: "Testing Laboratories",
    category: "testing_laboratories",
    code: "8734",
  },
  {
    description: "Theatrical Ticket Agencies",
    category: "theatrical_ticket_agencies",
    code: "7922",
  },
  { description: "Timeshares", category: "timeshares", code: "7012" },
  {
    description: "Tire Retreading and Repair",
    category: "tire_retreading_and_repair",
    code: "7534",
  },
  {
    description: "Tolls/Bridge Fees",
    category: "tolls_bridge_fees",
    code: "4784",
  },
  {
    description: "Tourist Attractions and Exhibits",
    category: "tourist_attractions_and_exhibits",
    code: "7991",
  },
  { description: "Towing Services", category: "towing_services", code: "7549" },
  {
    description: "Trailer Parks, Campgrounds",
    category: "trailer_parks_campgrounds",
    code: "7033",
  },
  {
    description: "Transportation Services (Not Elsewhere Classified)",
    category: "transportation_services",
    code: "4789",
  },
  {
    description: "Travel Agencies, Tour Operators",
    category: "travel_agencies_tour_operators",
    code: "4722",
  },
  {
    description: "Truck/Utility Trailer Rentals",
    category: "truck_utility_trailer_rentals",
    code: "7513",
  },
  {
    description: "Typesetting, Plate Making, and Related Services",
    category: "typesetting_plate_making_and_related_services",
    code: "2791",
  },
  {
    description: "Typewriter Stores",
    category: "typewriter_stores",
    code: "5978",
  },
  {
    description: "U.S. Federal Government Agencies or Departments",
    category: "u_s_federal_government_agencies_or_departments",
    code: "9405",
  },
  {
    description: "Uniforms, Commercial Clothing",
    category: "uniforms_commercial_clothing",
    code: "5137",
  },
  {
    description: "Used Merchandise and Secondhand Stores",
    category: "used_merchandise_and_secondhand_stores",
    code: "5931",
  },
  { description: "Utilities", category: "utilities", code: "4900" },
  { description: "Variety Stores", category: "variety_stores", code: "5331" },
  {
    description: "Veterinary Services",
    category: "veterinary_services",
    code: "0742",
  },
  {
    description: "Video Amusement Game Supplies",
    category: "video_amusement_game_supplies",
    code: "7993",
  },
  {
    description: "Video Game Arcades",
    category: "video_game_arcades",
    code: "7994",
  },
  {
    description: "Video Tape Rental Stores",
    category: "video_tape_rental_stores",
    code: "7841",
  },
  {
    description: "Vocational/Trade Schools",
    category: "vocational_trade_schools",
    code: "8249",
  },
  {
    description: "Watch/Jewelry Repair",
    category: "watch_jewelry_repair",
    code: "7631",
  },
  { description: "Welding Repair", category: "welding_repair", code: "7692" },
  { description: "Wholesale Clubs", category: "wholesale_clubs", code: "5300" },
  {
    description: "Wig and Toupee Stores",
    category: "wig_and_toupee_stores",
    code: "5698",
  },
  {
    description: "Wires, Money Orders",
    category: "wires_money_orders",
    code: "4829",
  },
  {
    description: "Womens Accessory and Specialty Shops",
    category: "womens_accessory_and_specialty_shops",
    code: "5631",
  },
  {
    description: "Womens Ready-To-Wear Stores",
    category: "womens_ready_to_wear_stores",
    code: "5621",
  },
  {
    description: "Wrecking and Salvage Yards",
    category: "wrecking_and_salvage_yards",
    code: "5935",
  },
];
